import request from 'superagent';
import {localeFull} from 'helpers/stableValues';
import {domain} from 'ferries/helpers/common';

export const subscribe = (email) => {
  const cuid = localStorage.getItem('cuid');

  const query = Object.assign({
    email,
    locale: localeFull
  }, cuid && {cuid});

  return request
    .get(`${domain}/api/v1/ferries/subscribe/email`).set('x-override-header', 'ferryscanner-web')
    .set('Content-Type', 'application/json')
    .query(query);
};
